import AvatarsContainer from "../../../Components/UiKits/Avatars";

export default function Avatars() {
    return (
        <div className='page-body'>
            <AvatarsContainer />
        </div>
    )
}
